export default __webpack_public_path__ + "static/media/main.9b236245.png";